import classNames from "classnames";
import { AscButton } from "../../components";
import { CheckActiveIcon } from "../../components/AscIcons";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import styles from "./AscTrialView.module.scss";

export interface AscTrialViewProps {
  className?: string;
  onContinue?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export default function AscTrialView({
  className,
  onContinue,
  loading = false,
  disabled = false,
}: AscTrialViewProps) {
  return (
    <AscAuthFlowLayout alignment="right" roundSideImage>
      <div
        data-testid="asc-trial-view"
        className={classNames(styles.ground, className)}
      >
        <header className={styles.heading}>
          <AscHeading className={styles.title} level={1}>
            Gain life changing skills for free!
          </AscHeading>
          <AscParagraph className={styles.subTitle}>
            Try it out for a week and see if you like it. We’re sure you’ll love
            it, so we’re not worried.
          </AscParagraph>
        </header>

        <div className={styles.trialBox}>
          <CheckActiveIcon className={styles.checkIcon} />
          <div className={styles.trialText}>Free 7-days trial for new user</div>
        </div>

        <footer className={styles.footer}>
          <AscButton
            className={styles.footerButton}
            variant="primary"
            size="large"
            fullWidth
            onClick={onContinue}
            disabled={disabled}
            loading={loading}
          >
            Continue
          </AscButton>
        </footer>
      </div>
    </AscAuthFlowLayout>
  );
}
